import Vue from 'vue'
import "reset-css";// 清除默认样式
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/Yong-font/iconfont.css'


import resize from "vue-element-resize-detector";

Vue.use(resize)

Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
